import Cookies from "./script-js.cookie.mjs";

// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.wishlist = function () {
  /**
   * @var {string}
   * The name of the cookie
   * Note: changing this name will reset it and all users will have to opt in again
   */
  const cookieName = "and-daughter-wishlist-NOV-2024";

  /**
   * @var {number}
   * How long in days should the cookie last
   */
  const cookieLengthInDays = 365;

  /**
   * @var {NodeListOf<HTMLButtonElement>} the <video> tag
   */
  const toggleButtons = document.querySelectorAll("[data-js-wishlist]");

  /**
   * Toggle items from wishlist
   */
  const toggle = (event) => {
    const productHandle = event.currentTarget.getAttribute(
      "data-product-handle"
    );

    if (!productHandle) {
      console.error("No product Id found in wishlistx");
    }

    const button = event.currentTarget;

    if (button.getAttribute("aria-selected") === "true") {
      remove(productHandle);
      button.setAttribute("aria-selected", "false");
    } else {
      add(productHandle);
      button.setAttribute("aria-selected", "true");
    }
  };

  /**
   * Add item to wishlist
   */
  const add = (productHandle) => {
    const productsList = Cookies.get(cookieName);
    let products = [];

    if (productsList) {
      products = productsList.split(",");
    }

    products.push(productHandle);

    Cookies.set(cookieName, products, {
      expires: cookieLengthInDays,
      sameSite: "strict",
    });
  };

  /**
   * Remove item from wishlist
   *
   */
  const remove = (productHandle) => {
    const productsList = Cookies.get(cookieName);

    if (!productsList) {
      return;
    }

    const products = productsList.split(",");

    const index = products.indexOf(productHandle);

    products.splice(index, 1);

    Cookies.set(cookieName, products, {
      expires: cookieLengthInDays,
      sameSite: "strict",
    });
  };

  /**
   * Remove all items from wishlist
   *
   */
  const removeAll = () => {
    Cookies.set(cookieName, "", {
      expires: 0,
      sameSite: "strict",
    });
  };

  /**
   * get product IDs from wishlist
   * if customer is not logged in get from cookie
   */
  const retrieve = () => {
    const products = Cookies.get(cookieName);

    if (products) {
      setButtonsState(products.split(","));
    }
  };

  /**
   * set toggle button to be selected or not
   */
  const setButtonsState = (products) => {
    for (let i = 0; toggleButtons.length > i; i++) {
      const productHandle = toggleButtons[i].getAttribute(
        "data-product-handle"
      );
      if (products.includes(productHandle)) {
        toggleButtons[i].setAttribute("aria-selected", "true");
      }
    }
  };

  /**
   * get the wishlist products
   * if customer is not logged in get from cookie
   */
  const getProducts = () => {
    const productsList = Cookies.get(cookieName);

    if (!productsList) {
      return;
    }

    const products = productsList.split(",");

    if (products) {
      for (let i = 0; products.length > i; i++) {
        const productURL = `products/${products[i]}.js`;

        if (productURL === "products/undefined.js") {
          return;
        } else {
          fetch(window.Shopify.routes.root + productURL)
            .then((response) => response.json())
            .then((product) => {
              const template = document.getElementById("wishlist-product");
              const container = document.getElementById("wishlist-container");

              const clone = template.cloneNode(true);
              clone.innerHTML = clone.innerHTML.replace(
                "[[PRODUCT_TITLE]]",
                product.title
              );

              clone.innerHTML = clone.innerHTML.replace(
                "[[PRODUCT_URL]]",
                product.handle
              );

              clone.innerHTML = clone.innerHTML.replace(
                "[[PRODUCT_IMAGE]]",
                product.featured_image
              );

              const fragment = document.importNode(clone.content, true);

              container.appendChild(fragment);
            });
        }
      }
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    // TODO add to document not the element itself
    for (let i = 0; toggleButtons.length > i; i++) {
      toggleButtons[i].removeEventListener("click", toggle);
      toggleButtons[i].addEventListener("click", toggle);
    }
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    addEventListeners();
    retrieve();
  };

  return {
    init,
    getProducts,
  };
};

window.AndDaughter.wishlist().init();
